import Router from 'preact-router';
import Match, { Link }  from 'preact-router/match';
import { createHashHistory } from 'history';
import { h, render, Component } from 'preact';
import CardMatch from './components/cards/';
import Spot from './components/spot/';
import BoardGame from './components/boardgame/';
import Layout from './components/layout/';
import Downloads from './components/downloads/';
import Puzzle from './components/puzzle/';
import Helmet from "preact-helmet";

import LiquidRoute, {FadeAnimation, PopAnimation} from 'liquid-route';
import 'liquid-route/style.css';

const activities = [
    {
        title:'Hidden Object',
        unique:'hidden-object',
        thumb:'/thumbs/seek-find-thumb.png',
        type:'spot',
        label: 'Seek and Find',
    },
    {
        title:'Memory Game',
        unique:'match-pairs-classic',
        thumb:'/thumbs/match-pairs-thumb.png',
        type:'match',
        ribbon:"Multiple Difficulties",
        ribbonColor:"pink",
    },
    {
        title:'River',
        unique:'river',
        thumb:'/thumbs/river-thumb.png',
        type:'spot'
    },
    {
        title:'Pirate Beach',
        unique:'pirate',
        thumb:'/thumbs/pirate-thumb.png',
        type:'spot'
    },
    {
        title:'Suchomimus',
        unique:'suchomimus',
        thumb:'/thumbs/suchomimus-thumb.png',
        type:'spot',
        ribbon:"Easy",
        ribbonColor:"yellow",
   },
    {
        title:'Gryposaurus',
        unique:'gryposaurus',
        thumb:'/thumbs/gryposaurus-thumb.png',
        type:'spot',
        ribbon:"Easy",
        ribbonColor:"yellow",
    },
    {
        title:'Edmontonia',
        unique:'edmontonia',
        thumb:'/thumbs/edmontonia-thumb.png',
        type:'spot',
        ribbon:"Easy",
        ribbonColor:"yellow",
    },
    {
        title:'Halloween',
        unique:'halloween',
        thumb:'/thumbs/halloween.png',
        type:'spot'
    },
    // {
    //     title:'Dinosaurs and Footprints',
    //     unique:'footprintsandslides',
    //     thumb:'/thumbs/snakes-and-ladders.png',
    //     coming_soon:true,
    //     type:'boardgame',
    // },
    // {
    //     title:'slidepuzzle',
    //     unique:'slidepuzzle01',
    //     thumb:'/thumbs/snakes-and-ladders.png',
    //     type:'slidepuzzle',
    // },
];
const onRouteChange = () => {
  if(typeof window !== 'undefined'){
    window.scrollTo(0, 0)
  }
}

const Main = () => (
	<div>
  <Helmet
          htmlAttributes={{lang: "en", amp: undefined}} // amp takes no value
          title="Dinosaurs Doing Stuff"
          meta={[
              {name: "description", content: "Dinosaur Activities"},
              {property: "og:type", content: "article"}
          ]}
          link={[
            {rel: "apple-touch-icon", sizes: "57x57", href:"/assets/icon/apple-icon-57x57.png"},
            {rel: "apple-touch-icon", sizes: "60x60", href:"/assets/icon/apple-icon-60x60.png"},
            {rel: "apple-touch-icon", sizes: "72x72", href:"/assets/icon/apple-icon-72x72.png"},
            {rel: "apple-touch-icon", sizes: "76x76", href:"/assets/icon/apple-icon-76x76.png"},
            {rel: "apple-touch-icon", sizes: "114x114", href:"/assets/icon/apple-icon-114x114.png"},
            {rel: "apple-touch-icon", sizes: "120x120", href:"/assets/icon/apple-icon-120x120.png"},
            {rel: "apple-touch-icon", sizes: "144x144", href:"/assets/icon/apple-icon-144x144.png"},
            {rel: "apple-touch-icon", sizes: "152x152", href:"/assets/icon/apple-icon-152x152.png"},
            {rel: "apple-touch-icon", sizes: "180x180", href:"/assets/icon/apple-icon-180x180.png"},
            {rel: "icon", type: "image/png", sizes: "192x192", href:"/assets/icon//android-icon-192x192.png"},
            {rel: "icon", type: "image/png", sizes: "32x32", href:"/assets/icon/favicon-32x32.png"},
            {rel: "icon", type: "image/png", sizes: "96x96", href:"/assets/icon/favicon-96x96.png"},
            {rel: "icon", type: "image/png", sizes: "16x16", href:"/assets/icon/favicon-16x16.png"}
          ]}
      />
        <Router history={createHashHistory()} onChange={onRouteChange()}>
        
        <Layout path="" isHome="true"><App/></Layout>
        <Layout default>
            <Router>
                <CardMatch path="/activity/match/:activity-id" />
                <Spot path="/activity/spot/:activity-id" />
                <BoardGame path="/activity/boardgame/:activity-id" />
                <Puzzle  path="/activity/slidepuzzle/:activity-id" />
            </Router>
        </Layout>
        </Router>

	</div>
);


class App extends Component {
    renderActivitycard(activity){
        let cardType = '';
        switch(activity.type){
            case 'spot':
                cardType = 'Spot The Difference';
            break;
            case 'match':
                cardType = 'Match The Cards';
            break;
            case 'boardgame':
                cardType = 'Board Game';
            break;
        }
        cardType = activity.label || cardType;
        if(!!activity.coming_soon) cardType = 'Coming Soon';
        let activityribbonClass = "ribbon " + (activity.ribbonColor ? activity.ribbonColor : '');
        let activityribbon = activity.ribbon ? (<div class={activityribbonClass}><em class="ribbon--inner">{activity.ribbon}</em></div>) : null;
        return (
            <Link className={'layout__activity' + (!!activity.coming_soon ? ' activity--soon' : '')} href={!activity.coming_soon ? '/activity/' + activity.type + '/' + activity.unique : '#'}>
                {activityribbon}
                <img src={`/assets${activity.thumb}`}/>
                <span>{cardType}</span>
                <h4>{activity.title}</h4>
            </Link>
        )
    }
    render() {
        return (
        	<div className="layout__activities">{activities.map(a => this.renderActivitycard(a))}</div>
    	);
    }
}

// render(<Main />, document.body);
export default Main



// WEBPACK FOOTER //
// ./index.js